import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=2784057b&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=2784057b&prod&scoped=true&lang=css&external"
import style1 from "@/assets/styles/webchat-style.scss?vue&type=style&index=1&prod&lang=scss&external"
import style2 from "./Dashboard.vue?vue&type=style&index=2&id=2784057b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2784057b",
  null
  
)

export default component.exports